import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { site } from '../config/site';

type Props = {
  links?: Array<{ to: string; label: string }>;
  ctaHref?: string;
  ctaLabel?: string;
};

export function SiteHeader({
  links = [
    { to: '/#glimpse', label: 'The app' },
    { to: '/#loop', label: 'How it works' },
    { to: '/#coach', label: 'Coach' },
    { to: '/#plans', label: 'Plans' },
  ],
  ctaHref = '/#download',
  ctaLabel = 'Get the app',
}: Props) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="wrap header-inner">
        <Link className="logo" to="/">
          <img src={site.logoUrl} alt="" height={36} width={28} />
          <span>MindHeart</span>
        </Link>
        <nav className="nav" aria-label="Primary">
          {links.map((link) =>
            link.to.startsWith('/#') ? (
              <a key={link.to} href={link.to}>
                {link.label}
              </a>
            ) : (
              <NavLink key={link.to} to={link.to}>
                {link.label}
              </NavLink>
            ),
          )}
          {ctaHref.startsWith('/#') ? (
            <a className="nav-cta" href={ctaHref}>
              {ctaLabel}
            </a>
          ) : (
            <Link className="nav-cta" to={ctaHref}>
              {ctaLabel}
            </Link>
          )}
        </nav>
      </div>
    </header>
  );
}
